export default class Utils {
  static formatClassName(gradeLevel, classNumber) {
    if (!gradeLevel || classNumber === null || classNumber === undefined) {
      return '班级';
    }
    
    const classNum = parseInt(classNumber);
    const gradeChineseNumbers = ['一', '二', '三', '四', '五', '六', '七', '八', '九'];
    
    if (gradeLevel >= 1 && gradeLevel <= 9) {
      const gradeName = gradeChineseNumbers[gradeLevel - 1];
      return `${gradeName}(${classNum})班`;
    } else if (gradeLevel === 10) {
      return `高一${classNum}班`;
    } else if (gradeLevel === 11) {
      return `高二${classNum}班`;
    } else if (gradeLevel === 12) {
      return `高三${classNum}班`;
    }
    
    return '班级';
  }

  static createDatepickerOptions(context) {
    return {
      firstDayOfWeek: 1,
      shortcuts: [{
        text: '前天',
        onClick(picker) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 2)
          picker.$emit('pick', date)
          context.highlightedShortcut = '前天'
        }
      }, {
        text: '昨天',
        onClick(picker) {
          const date = new Date()
          date.setTime(date.getTime() - 3600 * 1000 * 24)
          picker.$emit('pick', date)
          context.highlightedShortcut = '昨天'
        }
      }, {
        text: '今天',
        onClick(picker) {
          picker.$emit('pick', new Date())
          context.highlightedShortcut = '今天'
        }
      }],
      onPick: () => {
        // 每次选择日期后更新高亮状态
        context.$nextTick(() => {
          setTimeout(() => {
            context.setHighlightedShortcut && context.setHighlightedShortcut();
          }, 50);
        });
      },
      // 当日期面板打开时
      onOpen: () => {
        // 等待DOM更新完成后设置高亮
        context.$nextTick(() => {
          setTimeout(() => {
            // 确保打开时显示选中日期所在的月份
            if (context.$refs.datePicker && context.$refs.datePicker.picker) {
              context.$refs.datePicker.picker.value = new Date(context.currentDate);
              context.$refs.datePicker.picker.date = new Date(context.currentDate);
              context.$refs.datePicker.picker.resetView && context.$refs.datePicker.picker.resetView();
            }
            
            // 更新高亮状态
            context.setHighlightedShortcut && context.setHighlightedShortcut();
          }, 100);
        });
      }
      // 注意：Element UI的日期选择器不支持onClose事件，所以我们使用blur事件替代
    }
  }

  static calculateDateOffset(dateString) {
    const selectedDate = new Date(dateString)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    selectedDate.setHours(0, 0, 0, 0)
    const diffTime = selectedDate.getTime() - today.getTime()
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  }

  static onDatePickerFocus(context) {
    // 在下一个tick更新高亮状态
    context.$nextTick(() => {
      context.forceUpdateDatepickerHighlight()
    })
  }

  static onDatePickerBlur(context) {
    // 面板关闭时重置到选中日期所在的月份
    context.$nextTick(() => {
      // 延迟执行以确保面板完全关闭后再重置
      setTimeout(() => {
        // 确保下次打开时显示正确的月份
        if (context.$refs.datePicker && context.$refs.datePicker.picker) {
          context.$refs.datePicker.picker.value = new Date(context.currentDate);
          context.$refs.datePicker.picker.date = new Date(context.currentDate);
        }
      }, 100);
    });
  }

  static setHighlightedShortcut(context) {
    const offset = context.currentDateOffset
    if (offset === -2) {
      context.highlightedShortcut = '前天'
    } else if (offset === -1) {
      context.highlightedShortcut = '昨天'
    } else if (offset === 0) {
      context.highlightedShortcut = '今天'
    } else {
      context.highlightedShortcut = ''
    }
    
    // 强制更新日期选择器高亮状态
    context.forceUpdateDatepickerHighlight()
  }

  static forceUpdateDatepickerHighlight(context) {
    // 查找日期选择器中的快捷按钮并更新高亮状态
    context.$nextTick(() => {
      if (context.$refs.datePicker && context.$refs.datePicker.picker && context.$refs.datePicker.picker.$el) {
        // 使用更精确的选择器来定位快捷按钮
        const shortcuts = context.$refs.datePicker.picker.$el.querySelectorAll('.el-picker-panel__sidebar .el-picker-panel__shortcut')
        shortcuts.forEach((button) => {
          // 移除所有高亮类
          button.classList.remove('highlighted')
          
          // 根据按钮文本和highlightedShortcut状态添加高亮类
          if (button.textContent === context.highlightedShortcut) {
            button.classList.add('highlighted')
          }
        })
      }
    })
  }

  static exportStudentData(context) {
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const dateStr = `${month}月${day}日`;
    
    const unfinishedRecords = context.studentHistoryRecords.filter(record => !record.markedAsFinished);
    
    let exportText = '';
    exportText += dateStr + ' ' + context.currentSubject + '科目数据导出：学生' + context.selectedStudentName +
                 '，未订正作业共' + unfinishedRecords.length + '次';
    
    const typeCount = {};
    unfinishedRecords.forEach(record => {
      if (typeCount[record.typeName]) {
        typeCount[record.typeName]++;
      } else {
        typeCount[record.typeName] = 1;
      }
    });
    
    let typeStats = '';
    for (const typeName in typeCount) {
      if (typeCount.hasOwnProperty(typeName)) {
        typeStats += '，【' + typeName + '】' + typeCount[typeName] + '次';
      }
    }
    
    if (typeStats) {
      exportText += '（其中：' + typeStats.substring(1) + '）';
    }
    
    exportText += '\n\n';
    
    unfinishedRecords.forEach((record, index) => {
      exportText += '日期：' + context.formatDate(record.date) + '\n';
      exportText += '类型：' + record.typeName + '\n';
      if (record.content) {
        exportText += '内容：' + record.content + '\n';
      }
      if (index < unfinishedRecords.length - 1) {
        exportText += '\n';
      }
    });
    
    // 复制到剪贴板
    if (navigator.clipboard) {
      navigator.clipboard.writeText(exportText).then(() => {
        context.$message({
          type: 'success',
          message: '数据已复制到剪贴板!'
        });
      }).catch(err => {
        console.error('复制失败:', err);
        context.$message({
          type: 'error',
          message: '复制到剪贴板失败'
        });
      });
    } else {
      // 兼容旧版浏览器
      const textArea = document.createElement('textarea');
      textArea.value = exportText;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          context.$message({
            type: 'success',
            message: '数据已复制到剪贴板!'
          });
        } else {
          context.$message({
            type: 'error',
            message: '复制到剪贴板失败'
          });
        }
      } catch (err) {
        console.error('复制失败:', err);
        context.$message({
          type: 'error',
          message: '复制到剪贴板失败'
        });
      }
      document.body.removeChild(textArea);
    }
  }

  static extractStudentNamesFromLine(text, students) {
    const names = []
    
    // 遍历系统中的所有学生，获取他们的姓名后两位作为匹配目标
    const studentNameEndings = students.map(student => student.name.slice(-2))
    
    // 在原文本中查找所有匹配的学生姓名后两位
    studentNameEndings.forEach(ending => {
      // 检查该姓名后缀在文本中出现了多少次
      let startIndex = 0
      while (startIndex < text.length) {
        const index = text.indexOf(ending, startIndex)
        if (index === -1) break
        names.push(ending)
        startIndex = index + 1 // 从下一个位置继续查找，支持重复出现的名字
      }
    })
    
    return [...new Set(names)] // 去重
  }
}